import { createRouter, createWebHashHistory } from "vue-router";
import pages from "./routes.json";
import { readUser } from "@/stores/session.js";
import { writeStorage } from "@/utils/storage.js";
const views = import.meta.glob("./views/*.vue");
const openPaths = new Set([
  "/pages/home/login",
  "/pages/home/regist",
  "/pages/home/delegate",
  "/pages/mine/privacy",
]);
// Normalize OAuth parameters before the hash-history object caches its location.
prepareEntry();
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: () =>
        readUser()?.id ? "/pages/tabs/home" : "/pages/home/login",
    },
    ...pages.map((page) => ({
      path: page.path,
      component: views[`./views/${page.file}.vue`],
    })),
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
  scrollBehavior: () => ({ top: 0 }),
});
router.beforeEach((to) => {
  if (to.query.fid) writeStorage("wxfid", String(to.query.fid));
  if (!readUser()?.id && !openPaths.has(to.path))
    return {
      path: "/pages/home/login",
      query: {
        redirect: to.fullPath,
        ...(to.query.fid ? { fid: to.query.fid } : {}),
      },
    };
});
window.addEventListener("session-expired", () => {
  if (router.currentRoute.value.path !== "/pages/home/login")
    router.replace({
      path: "/pages/home/login",
      query: { redirect: router.currentRoute.value.fullPath },
    });
});
export function prepareEntry() {
  const query = new URLSearchParams(location.search);
  const code = query.get("code"),
    state = query.get("state"),
    fid = query.get("fid");
  if (fid) writeStorage("wxfid", fid);
  if (state && state !== "zwjl") writeStorage("wxfid", state);
  if (code || query.has("wechat_oauth")) {
    const redirect = location.hash.slice(1);
    const oauth = new URLSearchParams({ oauth: "1" });
    if (code) oauth.set("code", code);
    if (state) oauth.set("state", state);
    if (fid) {
      oauth.set("fid", fid);
      oauth.set("scan", "1");
    }
    if (
      redirect.startsWith("/pages/") &&
      !redirect.startsWith("/pages/home/login")
    )
      oauth.set("redirect", redirect);
    history.replaceState(
      null,
      "",
      `${location.pathname}#/pages/home/login?${oauth}`,
    );
  }
}
export default router;
